<template>
  <b-dropdown-item 
    variant="danger" 
    v-gk-confirm="{
      title: $gettext('Delete permanently?'),
      message: deleteWarningText,
      options: {
        warning: (item.status !== 'd') ? sentInvoiceWarningText : null,
        item: itemText + ' - ' + item.number,
        variant: 'danger',
        confirmText: $gettext('Delete permanently'),
        safeguard: (item.status !== 'd'),
        safeguardText: $gettext('I agree and understand the implications')
      },
      callback: (isQuotation) ? _deleteQuotation : _deleteInvoice,
      callbackParams: item.id
    }"
  >
    <font-awesome-icon icon="fa-regular fa-trash-can" />
    <span>{{ deleteText }}</span>
  </b-dropdown-item>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DropdownItemDelete',
  props: {
    isQuotation: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
    deleteWarningText () {
      return this.$gettext('You\'re about to delete this item permanently. This can\'t be undone.')
    },
    sentInvoiceWarningText () {
      return this.$gettext('Under Dutch law, it is prohibited to delete any invoices that have been sent and received by customers for services that have been delivered. In case you made a mistake in an invoice that has already been sent, you should not delete the incorrect invoice but send a new credit invoice, correcting your mistake.')
    },
    isCorrection () {
      return (this.item && this.item.correction !== null)
    },
    deleteText () {
      let text = this.$gettext('Delete invoice')
      if (this.isQuotation) {
        text = this.$gettext('Delete quotation')
      } else if (this.isCorrection) {
        text = this.$gettext('Delete correction')
      }
      return text
    },
    itemText () {
      let text = this.$gettext('INVOICE')
      if (this.isQuotation) {
        text = this.$gettext('QUOTATION')
      } else if (this.isCorrection) {
        text = this.$gettext('CORRECTION')
      }
      return text
    }
  },
  created () {
  },
  methods: {
    ...mapActions({ 
      deleteInvoice: "invoices/deleteInvoice",
      deleteQuotation: "invoices/deleteQuotation",
    }),
    _deleteInvoice (invoice_id) {
      this.deleteInvoice(invoice_id).then(() => {
        this.onDelete(invoice_id)
      })
    },
    _deleteQuotation (quotation_id) {
      this.deleteQuotation(quotation_id).then(() => {
        this.onDelete(quotation_id)
      })
    },
    onDelete (item_id) {
      this.$emit('invoice-deleted', item_id)
      this.$store.commit('setAlert', {
        title: this.$gettext('Item deleted'),
        text: this.$gettext('Item was deleted successfully'),
        variant: 'primary',
        duration: 4
      })
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
